
<!-- 用户档案 -->
<template>
  <div style=" ">
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header clearfix">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}用户档案 -->
            档案号：<span v-if="formData.profileNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
              formData.profileNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information"> 制单</span>
            <span v-else-if="formData.stat == 1" class="information">待审</span>
            <span v-else-if="formData.stat == 2" class="information">已审</span>
            <span v-else-if="formData.stat == 99" class="information">作废</span>
            <span v-else class="information"></span>
          </div>
          <div class="fr">
            <!--            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
            <!--            </el-button>-->
<!--            <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>-->
          </div>
        </div>
        <div style="display: flex; overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important;">

          <!-- 品牌信息 -->
          <div class="d-cont edit-mce-box" style="width: 80%; overflow: hidden;">
            <div class="d-item">
              <div class="title first">
                <b>主信息</b>
              </div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      用户类型
                    </th>
                    <td>
                      <el-select v-model="formData.custType" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option label="普通用户" :value="0" />
                        <el-option label="售前用户" :value="1" />
                        <el-option label="工程用户" :value="2" />
                        <el-option label="VIP用户" :value="3" />
                        <el-option label="经销商" :value="4" />
                      </el-select>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      创建方式
                    </th>
                    <td>
                      <el-select v-model="formData.createType" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option label="其他方式" :value="0" />
                        <el-option label="工单产生" :value="1" />
                        <el-option label="后台录入" :value="2" />
                        <el-option label="微信录入" :value="3" />
                        <el-option label="接口导入" :value="4" />
                      </el-select>
                    </td>
                    <th>
                      <em class="f-red">*</em>
                      用户名称
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.custName" :maxlength="30" clearable
                        style="width: 7vw !important;" />
                    </td>
                    <th>
                      机构名称
                    </th>
                    <td>
                      <org-search :org-name.sync="formData.orgName"
                                  :org-id-path.sync="formData.orgIdPath"
                                  :org-id.sync="formData.orgId"
                                  style="width: 7vw !important;"/>
<!--                      <el-cascader style="width: 7vw !important;;" v-model="orgValue" :options="orgOptions"-->
<!--                        @change="orgHandleChange"></el-cascader>-->
                    </td>
                  </tr>
                  <tr>
                    <th>
                      性别
                    </th>
                    <td>
                      <el-select v-model="formData.sex" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option label="男" :value="1" />
                        <el-option label="女" :value="2" />
                      </el-select>
                    </td>
                    <th>
                      VIP级别
                    </th>
                    <td>
                      <el-select v-model="formData.vipLevel" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option v-for="item in dictTypesVipLevel" :key="item.id" :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                    <th>
                      来电信息
                    </th>
                    <td>
                        <el-select v-model="formData.callInfo" placeholder="请选择" clearable style="width: 7vw;">
                          <el-option v-for="item in dictTypesCallInfo" :key="item.id" :label="item.label"
                                    :value="item.value">
                          </el-option>
                        </el-select>
                    </td>
                    <th>
                      性格类型
                    </th>
                    <td>
                      <el-select v-model="formData.natureType" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option v-for="item in dictTypesNatureType" :key="item.id" :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      文化水平
                    </th>
                    <td>
                      <el-select v-model="formData.educationLevel" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option v-for="item in dictTypesEducationLevel" :key="item.id" :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                    <th>
                      用户身份
                    </th>
                    <td>
                      <el-select v-model="formData.custIdentity" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option v-for="item in dictTypesCustIdentity" :key="item.id" :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                    <th>
                      风险把控
                    </th>
                    <td>
                      <el-select v-model="formData.custRisk" placeholder="请选择" clearable style="width: 7vw;">
                        <el-option v-for="item in dictTypesCustRisk" :key="item.id" :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </td>
                    <th>
                      来电号码
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.callMobile" :maxlength="30" clearable
                        style="width: 7vw !important;" />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      网点名称
                    </th>
                    <td>
                      <site-pop-search :site-id.sync="formData.siteId"
                                       :site-name.sync="formData.siteName"
                                       :org-id.sync="formData.orgId"
                                       :org-id-path.sync="formData.orgIdPath"
                                       :org-name.sync="formData.orgName"
                                       style="width: 7vw !important;"/>
<!--                      <el-input type="text" autocomplete="off" v-model="formData.siteName" :maxlength="20" clearable-->
<!--                        style="width: 7vw !important;;">-->
<!--                        <i slot="suffix" class="el-input__icon el-icon-search"-->
<!--                          @click="showPreconditionDialog2 = true"></i>-->
<!--                      </el-input>-->
                    </td>
                    <th>
                      源于工单
                    </th>
                    <td>
                      <span style="width: 7vw !important;">{{ formData.orderNo }}</span>
                    </td>
                    <th>
                      微信openId
                    </th>
                    <td>
                      <span style="width: 7vw !important;">{{ formData.openId }}</span>
                    </td>
                    <th>
                      状态
                    </th>
                    <td>
                      <span v-if="formData.stat === null || formData.stat === undefined"
                        style="width: 7vw !important;"></span>
                      <span v-if="formData.stat == 1">待审</span>
                      <span v-if="formData.stat == 2">已审</span>
                      <span v-if="formData.stat == 9">做废</span>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      特别事项
                    </th>
                    <td>
                      <el-input type="text" autocomplete="off" v-model="formData.specailRemark" :maxlength="30" clearable
                        style="width: 7vw !important;" />
                    </td>
                  </tr>
                  <tr>
                    <th>创建人</th>
                    <td>{{ formData.createBy }}</td>
                    <th>创建时间</th>
                    <td>{{ formData.createTime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div class="title first">
                <!-- <b>用户地址</b> -->
                <el-button type="primary" class="button-sty btn_zdy" @click="showAreaDialog = true; areaObj = null">
                  <i class="el-icon-plus"></i>
                  新增地址
                </el-button>
                <el-button type="primary" class="button-sty btn_zdy" @click="deleteAddress">
                  <i class="el-icon-delete"></i>
                  删除
                </el-button>
              </div>
              <vxe-table :stripe="true"
                :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                :header-row-style="{ height: '36px' }"
                :row-style="{height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                ref="xTable" height="150" :row-config="{ height: 36 }" :column-config="{ resizable: true }"
                :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }" :data="formData.basCustAddressList"
                @checkbox-change="selectAddressChangeEvent"
                @checkbox-all="selectAddressChangeEvent"
                >

                <vxe-column type="checkbox" width="35"/>
                <vxe-column field="custName" title="联系人" width="110" />
                <vxe-column field="custMobile" title="联系方式" width="110" />
                <vxe-column field="custPhone1" title="其他电话1" width="110" />
                <vxe-column field="custPhone2" title="其他电话2" width="110" />
                <vxe-column title="地址" width="180">
                  <template #default="{ row }">
                    <span>{{ row.custProvince }}{{ row.custCity }}{{ row.custCounty }}{{ row.custTown }}</span>
                  </template>
                </vxe-column>
                <vxe-column field="custAddress" title="详细地址" width="180" />
                <vxe-column field="isDefault" title="是否默认地址" width="100">
                  <template #default="{ row }">
                    <span v-if="row.isDefault == 1">是</span>
                    <span v-if="row.isDefault == 0">否</span>
                  </template>
                </vxe-column>
                <vxe-column title="操作" width="50">
                  <template #default="{ row }">
                    <a href="javascript:void(0);" class="a-link" @click="editArea(row)">
                      <el-tooltip effect="dark" content="编辑" placement="top" popper-class="tooltip-skin">
                        <i class="el-icon-edit" />
                      </el-tooltip>
                    </a>
                  </template>
                </vxe-column>
              </vxe-table>
            </div>
            <div class="d-item">
              <div class="title first"><b>用户资产</b>
                <el-button type="primary" class="button-sty btn_zdy" @click="showPreconditionDialog = true; obj = null"
                  style="margin-left: -45px;">
                  <i class="el-icon-plus"></i>
                  新增产品
                </el-button>
                <el-button type="primary" class="button-sty btn_zdy" @click="deleteAsse"
                  style="margin-left: 5px;">
                  <i class="el-icon-delete"></i>
                  删除产品
                </el-button>
              </div>
              <vxe-table :stripe="true"
                :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                :header-row-style="{ height: '36px' }"
                :row-style="{ height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                ref="xTable" height="150" :row-config="{ height: 36 }" :column-config="{ resizable: true }"
                :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }" :data="formData.basCustAsseList"
                @radio-change="currentChange"
                >
                <vxe-column type="radio" width="35"/>
                <vxe-column field="brandName" title="品牌名称" width="" />
                <vxe-column field="itemName" title="产品名称" width="" />
                <vxe-column field="stat" title="资产状态" width="">
                  <template #default="{ row }">
                    <span v-if="row.stat == 1">可用</span>
                    <span v-if="row.stat == 0">不可用</span>
                  </template>
                </vxe-column>
                <vxe-column field="barcode" title="主条码" width="" />
                <vxe-column field="instDate" title="安装时间" width="" />
                <vxe-column field="standPeriodMonth" title="基本保修期(按月)" width="120" />
                <vxe-column field="extendPeriodMonth" title="延长保修期(按月)" width="120" />
                <vxe-column title="操作" width="50">
                  <template #default="{ row }">
                    <a href="javascript:void(0);" class="a-link" @click="edit(row)">
                      <el-tooltip effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                        <i class="el-icon-edit" />
                      </el-tooltip>
                    </a>
                  </template>
                </vxe-column>
              </vxe-table>


            </div>
            <div class="d-item">
              <div class="title first"><b>用户权益</b>
              </div>
              <div>
               <div v-if="formData.basCustRightsList.length>0">
                 <div  class="quanYi" style="width:;height: 100px;width:70% "  v-for="item in formData.basCustRightsList" :key="item.id">
                  <p class="quanYi_item">
                    <span class="sapn1" style="width:25%">
                      <span class="span1" style="font-size: 15px;color: black;">{{ item.rightsName }}*</span>
                      <span class="span2" v-if="item.rightsStat == null || item.rightsStat == undefined">未激活</span>
                      <span class="span2" v-if="item.rightsStat == 0">未激活</span>
                      <span class="span2" v-if="item.rightsStat == 1">有效</span>
                      <span class="span2" v-if="item.rightsStat == 3">失效</span>
                      <span class="span2" v-if="item.rightsStat == 9">做废</span>
                    </span>
                    <span class="sapn1" style="width:25%">
                      <span class="span1">权益码：</span><span class="span2">{{ item.rightsNo }}</span>
                    </span>
                    <span class="sapn1" style="width:50%"><span class="span1" style="width:9vw">有效时间：</span><span class="span2">{{ item.beginDate.split(" ")[0]}}-{{ item.endDate.split(" ")[0] }}
                    </span></span>
                  </p>
                  <p class="quanYi_item">
                    <span class="sapn1" style="width:25%">
                      <span class="span1">权益名称：</span><span class="span2">{{ item.rightsName }}</span>

                    </span>
                    <span class="sapn1" style="width:25%">
                      <span class="span1">绑定条码：</span><span class="span2">{{ item.barcode }}</span>
                    </span>
                    <span class="sapn1" style="width:50%" v-if="item.countTimesType==2">
                      <span class="span1" style="width:9vw">已使用/可使用次数：</span><span class="span2">{{ item.uesedTimes}}/{{ item.unUesedTimes }}
                    </span></span>
                    <span class="sapn1" style="width:50%" v-else>
                      <span class="span1" style="width:9vw">权益时间：</span><span class="span2">{{ item.uesedTimes }}个月
                    </span></span>

                  </p>
              <p style="float: right;margin: 0; margin-right: 20px; ">
                <span class="clause" >查看权益条款</span>
                <span  class="clause" style="margin-left: 20px;" @click="openRecordDialog(item.id)">查看核销记录</span></p>
                </div>
              </div>
                <div v-else style="text-align: center;font-size: 14px;color: #606266;">暂无数据 </div>
              </div>




            </div>
            <div class="d-item" style="height: 200px;" @reload="$reloadHandle">
              <div class="title first"><b>更换配件</b>
              </div>
              <vxe-table :column-config="{ resizable: true }" :stripe="true"
                :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                :header-row-style="{ height: '36px' }"

                :row-style="{ height: '30px', fontSize: '12px', background: '#fff' }" show-overflow keep-source
                ref="aaaa" height="100" :data="partsList"
                :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }">
                <vxe-column field="partsName" title="新配件名称" width="" />
                <vxe-column field="partsCode" title="新配件编码" width="" />
                <vxe-column field="oldPartsName" title="旧配件名称" width="" />
                <vxe-column field="oldPartsCode" title="旧配件编码" width="" />
                <vxe-column field="sitePrice" title="网点价" width="" />
                <vxe-column field="qty" title="更换数量" width="" />
                <vxe-column field="amount" title="金额" width="" />
                <vxe-column field="returnQty" title="网点返厂数量" width="" />
                <vxe-column field="returnRevQty" title="返厂数量" width="" />
                <vxe-column field="isNeedReturn" title="是否需要返厂" width="">
                  <template #default="{ row }">
                    <span v-if="row.isNeedReturn == 1">是</span>
                    <span v-if="row.isNeedReturn == 0">否</span>
                  </template>
                </vxe-column>
                <vxe-column field="isCheck" title="是否已经审核" width="">
                  <template #default="{ row }">
                    <span v-if="row.isCheck == 1">是</span>
                    <span v-if="row.isCheck == 0">否</span>
                  </template>
                </vxe-column>
              </vxe-table>


            </div>
            <div style="height:120px"></div>
          </div>
          <div style="" class="bread">
            <div style="height: 100%; overflow: auto">
              <div class="title_icon"><i class="el-icon-date"></i></div>
              <span style="margin-left: 10px;">服务工单 ({{ formData.orderList != null ? formData.orderList.length : 0
              }})</span>
              <div>
                <div v-if="formData.orderList != null" class="card" v-for="item in formData.orderList" :key="item.id">
                  <div class="card-item1"><span>{{ item.orderNo }}</span> <span class="details"
                      @click="drawer = true; orderId = item.id">详情</span>
                  </div>
                  <div>
                    <span>工单状态: </span>
                    <span v-if="item.stat == null || item.stat == undefined"></span>
                    <span v-if="item.stat == 1">登记</span>
                    <span v-if="item.stat == 2">发布</span>
                    <span v-if="item.stat == 5">已派网点</span>
                    <span v-if="item.stat == 9">已派师傅</span>
                    <span v-if="item.stat == 13">已出发</span>
                    <span v-if="item.stat == 17">已上门</span>
                    <span v-if="item.stat == 20">完工暂存</span>
                    <span v-if="item.stat == 21">已完工</span>
                    <span v-if="item.stat == 22">网点确认完工</span>
                    <span v-if="item.stat == 23">中心确认完工</span>
                    <span v-if="item.stat == 24">总部确认完工</span>
                    <span v-if="item.stat == 91">待结算</span>
                    <span v-if="item.stat == 92">结算驳回</span>
                    <span v-if="item.stat == 93">结算中止</span>
                    <span v-if="item.stat == 94">已结算</span>
                    <span v-if="item.stat == 98">挂起</span>
                    <span v-if="item.stat == 99">99取消</span>
                  </div>
                  <div><span>服务类型: </span><span>{{ item.serverTypeName }}</span></div>
                  <div><span>创建时间: </span><span>{{ item.createTime }}</span></div>
                  <div><span>完工时间: </span><span>{{ item.completeTime }}</span></div>
                  <div><span>服务网点: </span><span>{{ item.siteName }}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <preconditionDialog v-if="showPreconditionDialog" @commitData="commitData" :obj="obj"
        :visiable.sync="showPreconditionDialog" multi="true" />

      <areaDialog v-if="showAreaDialog" @commitData="commitAreaData" :areaObj="areaObj" :visiable.sync="showAreaDialog"
        multi="true" />
        <!-- 核销记录 -->
        <recordDialog v-if="recordDialog"  :areaObj3="areaObj3" :visiable.sync="recordDialog"
        multi="true" />

      <!-- 网点名称弹窗 -->
      <nameDialog v-if="showPreconditionDialog2" @commit="commitSelectedRow" :visiable.sync="showPreconditionDialog2"
        multi="true" />
    </div>

    <orderDialog @closeD="closeD" :visible.sync="drawer" v-if="drawer" :row1="orderId" />


  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
// 新增产品弹窗
import preconditionDialog from "./dialog.vue";
import areaDialog from "./areaDialog.vue";
// 核销记录
import recordDialog from "./recordDialog.vue";

// 服务网点名称
import nameDialog from '@/views/dialogCommon/radioSiteDialog.vue';
import orderDialog from '@/views/dialogCommon/detailsDialog.vue'
import api from "@/api/projectApi";
import detailsDialog from "@/views/dialogCommon/detailsDialog.vue";
import OrgSearch from "@/components/formItem/orgSearch.vue";
import SitePopSearch from "@/components/formItem/sitePopSearch.vue";


export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    SitePopSearch,
    OrgSearch,
    detailsDialog,
    preconditionDialog,
    nameDialog,
    Tinymce,
    areaDialog,
    orderDialog,
    // 核销记录
    recordDialog
  },
  data() {
    return {
      selectAddressData: null,
      selectItemData: null,

      dictTypesVipLevel: [],
      dictTypesCallInfo: [],
      dictTypesNatureType: [],
      dictTypesEducationLevel: [],
      dictTypesCustIdentity: [],
      dictTypesCustRisk: [],
      drawer: false,
      orderId: null,

      getDataUrl1: '/basic/basCustAsset/getById',
      addDataUrl: '/basic/basCustProfile/add',
      updateDataUrl: '/basic/basCustProfile/update',
      echoAddressUrl: '/basic/basArea/getAreaOptionByAreaId',
      getTableDataUrl: '/basic/basCustAsset/getList',
      // getBrandListUrl: '/basic/snCompanyBrand/getBrandList',
      // getServiceTypeUrl: '/basic/basServiceType/getList',
      // getItemCategoryTypeUrl: '/basic/basItemCategory/getList',


      formData: {
        basCustRightsList:[],
        id: '',
        custType: 0,  // 用户类型：0普通用户 、1、售前用户、2工程用户、3VIP用户、4经销商
        createType: 0,  // 创建方式：0其他方式；1工单产生；2后台录入；3微信录入；4接口导入
        custName: '',  // 用户名称
        // custMobile: '',  // 联系方式,同厂商下惟一
        // custPhone1: '',  // 其他电话1
        // custPhone2: '',  // 其他电话2
        // custProvince: '',  // 省
        // custCity: '',  // 市
        // custCounty: '',  // 县
        // custTown: '',  // 街道
        // areaId: 0,  // 关联xx_area.id
        // custAddress: '',  // 详细地址
        orgId: '',  // 机构ID，关联脚手架机构表.id
        orgName: '',  // 机构名称,冗余字段
        orgIdPath: '',  // 机构ID路径,冗余字段.重要
        siteId: 0,  // 服务网点ID,关联sn_user.id
        siteName: '',  // 服务网点名称,冗余字段
        orderId: 0,  // 源于工单ID,关联sp_order.id
        orderNo: '',  // 源于工单号,冗余字段
        openId: '',  // 微信openId
        stat: 1,  // 状态：1待审、2已审、9做废

        /** 性别:1男2女 */
        sex: null,
        /** VIP级别ID，关联脚手架数据字典项目表sys_dict_item.id */
        vipLevel: null,
        /** 来电信息ID，关联脚手架数据字典项目表sys_dict_item.id */
        callInfo: null,
        /** 性格类型ID，关联脚手架数据字典项目表sys_dict_item.id */
        natureType: null,
        /** 文化水平ID，关联脚手架数据字典项目表sys_dict_item.id */
        educationLevel: null,
        /** 用户身份ID，关联脚手架数据字典项目表sys_dict_item.id */
        custIdentity: null,
        /** 风险把控ID，关联脚手架数据字典项目表sys_dict_item.id */
        custRisk: null,
        /** 来电号码 */
        callMobile: null,
        /** 特别事项 */
        specailRemark: null,

        basCustAsseList: [],
        basCustAddressList: [],
        orderList: [],
      },

      tableData: [],
      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      tabIndex: 'first',
      dataId: '',

      showAreaDialog: false,
      recordDialog: false,

      showParts: true,
      showProductCategoryDialog: false,
      showPreconditionDialog: false,
      showPreconditionDialog2: false,

      areaObj: null,
      areaObj3: null,
      obj: {},
      orgOptions: [],
      orgValue: [],

      assetList: [],
      partsList: []
    }
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },

  mounted() {
    this.getData()
    this.loadOrgData()
    this.getDictTypes()
    // this.getTableData()
  },
  methods: {
    openRecordDialog(e){

      console.log(e,"点击的权益id");
      this.areaObj3 = e
      this.recordDialog = true

    },
    getDictTypes(){
      this.$http({
        url: "/admin/dict/type/vip_level",
        method: 'get',
      }).then(res => {
        this.dictTypesVipLevel = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/call_info",
        method: 'get',
      }).then(res => {
        this.dictTypesCallInfo = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/nature_type",
        method: 'get',
      }).then(res => {
        this.dictTypesNatureType = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/education_level",
        method: 'get',
      }).then(res => {
        this.dictTypesEducationLevel = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/cust_identity",
        method: 'get',
      }).then(res => {
        this.dictTypesCustIdentity = res.data.data;
      })
      this.$http({
        url: "/admin/dict/type/cust_risk",
        method: 'get',
      }).then(res => {
        this.dictTypesCustRisk = res.data.data;
      })
    },
    closeD() {
      this.drawer = false
    },
    // 明细勾选
    selectAddressChangeEvent(data) {
      this.selectAddressData = data.records
    },
    selectItemChangeEvent(data) {
      this.selectItemData = data.records
    },
    // 地址删除
    deleteAddress() {
      this.$baseConfirm('您确定要删除已选地址吗？').then(() => {
        let temp = this.formData.basCustAddressList;
        this.selectAddressData.forEach(item => {
          temp = temp.filter(item1 => item1.id != item.id)
        })
        this.formData.basCustAddressList = temp
      })
    },
    // 资产删除
    deleteAsse() {
      this.$baseConfirm('您确定要删除已选资产吗？').then(() => {
        let temp = this.formData.basCustAsseList
        this.selectItemData.forEach(item => {
          temp = temp.filter(item1 => item1.id != item.id)
        })
        this.formData.basCustAsseList = temp
      })
    },
    currentChange({ row }) {
      console.log('row', row)
      this.selectItemData = [row]
      if (row.id) {
        // this.showParts = false
        this.$http({
          url: api.basCustAsset.getPartsDataUrl,
          method: 'post',
          data: { id: row.id
 }
        }).then(res => {
          if (res.data.data.length !== 0 && res.data.data[0] != null) {
            this.partsList = res.data.data
          } else {
            this.partsList = []
          }
          // this.showParts = true
        })
      } else {
        console.log('kong',);
        this.partsList = []
      }
      console.log(this.partsList,"partsList的值");
      // this.reload()

      // this.$refs['aaaa'].commitProxy('reload');

    },

    editArea(row) {
      this.areaObj = row
      this.showAreaDialog = true
    },

    edit(row) {
      this.obj = row
      this.showPreconditionDialog = true
      // this.openTheNewPopover(true, data)
    },




    // 选中网点
    commitSelectedRow(data) {
      this.formData.siteId = data.id
      this.formData.siteName = data.name

    },


    // 加载机构数据
    loadOrgData() {
      this.$http({
        url: api.sysDept.getDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        this.orgOptions = []
        res.data.data.forEach(item => {
          let temp = {
            value: item.id,
            label: item.name,
          }
          if (item.hasChild) {
            temp.children = []
            item.child.forEach(item1 => {
              temp.children.push({
                value: item1.deptId,
                label: item1.name
              })
            })
          }

          this.orgOptions.push(temp)
        })
      })
    },


    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })

      }

    },

    commitAreaData(data) {
      let filter = this.formData.basCustAddressList.filter(item => item.id != data.id)
      if (data.isDefault == 1) {
        filter.forEach(item => {
          item.isDefault = 0
        })
      }
      filter.push(data)

      this.formData.basCustAddressList = filter
    },

    commitData(data) {
      console.log(data, 'commitData')
      let temp = this.formData.basCustAsseList.filter(item => item.id != data.id)
      temp.push(data)
      this.formData.basCustAsseList = temp
      // if (isRefresh) {
      //   this.getTableData()
      // } else {
      //   if (this.formData.basCustAsseList.length !== 0) {
      //     this.formData.basCustAsseList = this.formData.basCustAsseList.filter(item => item.id !== data.id)
      //   }
      //   this.formData.basCustAsseList.push(data)
      // }
      // console.log(this.formData.basCustAsseList, '---------')
    },

    //新增产品按钮功能
    openTheNewPopover(flag, data) {
      if (flag) {
        this.obj = data
      } else {
        this.obj = {
          profileId: '',
          id: '',
          brand: { value: '', label: '' },
          barcode: '',
          barcode2: '',
          stat: 1,
          brandId: '',
          brandName: "",
          itemId: '',
          itemCode: "",
          itemName: "",
          bigCategoryId: '',
          bigCategoryName: '',
          smallCategoryId: '',
          smallCategoryName: '',
          extendPeriodMonth: 0,
          standPeriodMonth: 0,
          careDate: '',
          fixDate: '',
          instDate: '',
          picList1: [],
          picList2: [],
          picList3: [],
          activeStat: 0,
          repairCardNo: '',
          contractFile: [],
        }
      }

      this.obj.profileId = this.dataId !== '' ? this.dataId : ''
      console.log(this.obj)
      this.showPreconditionDialog = true

    },


    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.basCustProfile.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log('res', response.data.data)
          this.formData = response.data.data
          this.orgValue = this.formData.orgIdPath.split('/')

          // this.getTableData()
        })
      }
    },

    // // 产品回显
    // getTableData() {
    //   this.$http({
    //     url: this.getTableDataUrl,
    //     method: 'post',
    //     data: {
    //       id: this.dataId
    //     }
    //   }).then(res => {
    //     this.formData.basCustAsseList = res.data.data
    //   })
    // },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              // this.$emit('editViewDataUpdate')
              // this.$baseReload()
              this.reload()
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
            })
          });
        }
      })
    },

    openEditDialog(row) {
      if (this.dataId !== '') {
        this.$http({
          url: this.getDataUrl1,
          method: 'post',
          data: { id: row.id }
        }).then(res => {
          this.obj = res.data.data
          this.obj.brand = { value: this.obj.brandId, label: this.obj.brandName }
          this.showPreconditionDialog = true
        })
      } else {
        console.log(row)
        this.obj = row
        this.obj.brand = { value: row.brandId, label: row.brandName }
        this.showPreconditionDialog = true
      }
    }
  }

}
  ;

</script>
<style lang="scss" scoped>
#containt .table-detail tbody tr th {
  white-space: nowrap;
  width: 6vw;
}

#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
}

.btn_zdy {
  // margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}


.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  width: 20%;
  margin-top: 10px;
  margin-left: 5px;

  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// 右边卡片样式
.card {
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;

  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  background-color: #f2f2f2;
  padding-left: 10px !important;
  padding-right: 5px;
  padding-bottom: 20px;
  margin-bottom: 20px;

  .card-item1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    span {
      font-size: 13px;
      font-weight: 550;
    }

    .details {
      text-decoration: underline;
      color: #00c4b3 !important;
    }
  }

  >div {
    margin-bottom: 8px;
  }
}


.el-scrollbar__wrap {
  margin-bottom: -16px !important;
}

.el-drawer.ltr,
.el-drawer.rtl {
  height: 100%;
  top: 0;
  bottom: 0;
  background-color: #cbcbcb;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

.quanYi {
  padding-top: 5px;
  border-radius: 10px 10px 0 0;
  color: #353535 !important;
  font-size: 10px;
  background-image: url('./img/1.png');
  background-size: 100% 100%;

  .quanYi_item {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;

    .sapn1 {
      display: inline-block;
        // width: 30%;
      .span1 {
        display: inline-block;
        width: 6vw;
        text-align: right;
      }

      .span2 {
        display: inline-block;
        // width: 8vw;
        text-align: left;
      }

    }
  }
}

.quanYi2 {
  padding-top: 5px;
  border-radius: 10px 10px 0 0;
  color: #353535 !important;
  font-size: 14px;
  background-image: url('./img/0.png');
  background-size: 100% 100%;

  .quanYi_item {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;

    .sapn1 {
      .span1 {
        display: inline-block;
        // width: 30%;
        text-align: right;
      }

      .span2 {
        display: inline-block;
        width: 8vw;
        text-align: left;
      }

    }
  }
}
// 权益条款
.clause{
text-decoration: underline;
color: #000;

}
</style>
